<template>

  <!-- Gallery Slide Overlay -->
  <div
    v-if="slide"
    class="gallery-slide-overlay">

    <!-- Info -->
    <div
      :class="{top}"
      class="gallery-slide-overlay__info">

      <!-- Title -->
      <div
        v-if="slide.title.ru"
        class="gallery-slide-overlay__title">

        <router-link
          :to="slide.link"
          class="gallery-slide-overlay__link">

          <q-icon
            size="xs"
            v-if="slide.link"
            name="fa lni-pointer-right"/>

          {{ slide.title.ru }}

        </router-link>

      </div>

      <!-- Description -->
      <div
        v-if="slide.description.ru"
        class="gallery-slide-overlay__description xs-hide">
        {{ slide.description.ru }}
      </div>

      <!-- Reference -->
      <div
        v-if="slide.reference.ru"
        class="gallery-slide-overlay__reference xs-hide">
        {{ slide.reference.ru }}
      </div>

    </div>

  </div>

</template>

<script>

  export default {
    name: 'gallery-slide-overlay',
    props: {
      slide: {
        type: Object,
        default: null,
      },
      top: {
        type: Boolean,
        default: false,
      },
    },
  };

</script>

<style lang="scss">

  .gallery-slide-overlay {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    pointer-events: none;

    &__info {
      left: 0;
      bottom: 0;
      display: flex;
      max-width: 80%;
      position: absolute;
      flex-direction: column;
      align-items: flex-start;
      padding: map-get($space-md, x);
    }

    &__info.top {
      top: 0;
      bottom: inherit;
    }

    &__title,
    &__reference,
    &__description {
      padding: 4px 10px;
      background-color: white;
    }

    &__title {
      font-size: 1.3rem;
    }

    &__title i {
      top: -3px;
      margin-right: 3px;
      position: relative;
    }

    &__link {
      pointer-events: auto;
    }

    &__reference {
      font-size: .8rem;
      letter-spacing: .03rem;
    }
  }

</style>
